export default "__VITE_ASSET__rImgmwnb__"